// dependencies
import React, { useState } from 'react';
import { Link, useHistory } from 'react-router-dom';
import Swal from 'sweetalert2';
import { omit } from 'lodash';
import './Home.css';

const Home = () => {
   const [formData, setFormData] = useState({
      roll: '',
      semester: '',
      fromRoll: '',
      toRoll: '',
      semesterg: '',
   });

   const [isSingle, setIsSingle] = useState(true);

   const [errors, setErrors] = useState({
      rolErr: '',
      fromRollErr: '',
      toRollErr: '',
   });

   const [rangeError, setRangeError] = useState({
      startRollRange: '',
      endRollRange: '',
   });

   const history = useHistory();

   // form validation
   const validation = (e) => {
      // validation logic
      switch (e.target.name) {
         case 'roll':
            if (e.target.value.length !== 6 && e.target.value.length !== 0) {
               setErrors({
                  ...errors,
                  rollErr: 'The roll must have 6 digits!',
               });
            } else {
               let newObj = omit(errors, 'rollErr');
               setErrors(newObj);
            }
            break;

         case 'fromRoll':
            // check the roll has 6 digits or not
            if (e.target.value.length !== 6 && e.target.value.length !== 0) {
               setErrors({
                  ...errors,
                  fromRollErr: 'Start roll must have 6 digits',
               });
            } else {
               let newObj = omit(errors, 'fromRollErr');
               setErrors(newObj);
            }

            // check the range is less then the end roll
            if (
               formData.toRoll &&
               parseInt(e.target.value) >= parseInt(formData.toRoll)
            ) {
               setRangeError({
                  ...rangeError,
                  startRollRange: 'Start roll must be less than End roll',
               });
            } else {
               rangeError.endRollRange = '';
               let newObj = omit(rangeError, 'startRollRange');
               setRangeError(newObj);
            }
            break;

         case 'toRoll':
            // check the roll has 6 digits or not
            if (e.target.value.length !== 6 && e.target.value.length !== 0) {
               setErrors({
                  ...errors,
                  toRollErr: 'End roll must have 6 digits',
               });
            } else {
               let newObj = omit(errors, 'toRollErr');
               setErrors(newObj);
            }

            // check the range is less then the end roll
            if (
               formData.fromRoll &&
               parseInt(e.target.value) <= parseInt(formData.fromRoll)
            ) {
               setRangeError({
                  ...rangeError,
                  endRollRange: 'End roll must be greater than Start roll',
               });
            } else {
               rangeError.startRollRange = '';
               let newObj = omit(rangeError, 'endRollRange');
               setRangeError(newObj);
            }
            break;

         default:
            break;
      }
   };

   const handleChange = (e) => {
      // update formData state with given form data
      switch (e.target.name) {
         case 'roll':
            setFormData({
               ...formData,
               roll: e.target.value,
            });
            break;

         case 'semester':
            setFormData({
               ...formData,
               semester: e.target.value,
            });
            break;

         case 'fromRoll':
            setFormData({
               ...formData,
               fromRoll: e.target.value,
            });
            break;

         case 'toRoll':
            setFormData({
               ...formData,
               toRoll: e.target.value,
            });
            break;

         case 'semesterg':
            setFormData({
               ...formData,
               semesterg: e.target.value,
            });
            break;

         default:
            break;
      }

      validation(e);
   };

   // handle result type
   const handleResultType = (e) => {
      // clear all input fields
      Array.from(document.querySelectorAll('input')).forEach(
         (input) => (input.value = '')
      );

      // update selection state
      switch (e.target.id) {
         case 'group':
            setErrors({ rolErr: '' });
            setIsSingle(false);
            break;

         case 'single':
            setErrors({ fromRollErr: '', toRollErr: '' });
            setRangeError({ startRollRange: '', endRollRange: '' });
            setIsSingle(true);
            break;

         default:
            break;
      }
   };

   const handleForm = (e) => {
      e.preventDefault();
      if (
         Object.values(errors).every((x) => x === '') &&
         Object.values(rangeError).every((y) => y === '')
      ) {
         isSingle
            ? history.push('/result', formData)
            : history.push('/groupresults', formData);
      } else {
         Swal.fire({
            title: 'Error Occurred !',
            html: 'Please fill up the input fields correctly.',
            icon: 'error',
            showCloseButton: 'true',
            background: '#343A46',
            color: '#EBECF0',
            confirmButtonColor: '#087EA4',
            confirmButtonText: 'Okay',
         });
      }
   };

   return (
      <div className="home-content content">
         <div className="content-wrapper">
            <h1 className="common-blue main-heading text-center">
               Diploma In Engineering Result
            </h1>

            {isSingle ? (
               <div className="home-img text-center">
                  <img src="img/home-img.svg" alt="home" />
               </div>
            ) : (
               <div className="home-img text-center">
                  <img src="img/group-bg.svg" alt="home" />
               </div>
            )}

            <p className="home-para text-center common-blue">
               The exam results of regular and irregular students of the 5th,
               and 7th semesters are available here!
               {/* (Board challenge results included)  */}
               <br />
               Also, you can try out the{' '}
               <span className="underlined text">
                  <Link style={{ color: '#1f8fe5' }} to="/cgpacalculator">
                     CGPA Calculator
                  </Link>
               </span>
               .
            </p>

            {/*  and the referred students of the 4th, 5th, 6th, and
               7th semesters */}

            {/* select form type */}
            <form style={{ textAlign: 'center' }}>
               <label
                  style={{ fontSize: '18px' }}
                  className="common-blue"
                  htmlFor="single"
               >
                  Select Result Type
               </label>
               <br />
               <input
                  onClick={(e) => handleResultType(e)}
                  type="radio"
                  id="single"
                  name="options"
                  defaultChecked
               />
               <label
                  style={{ marginRight: '50px' }}
                  className="common-blue"
                  htmlFor="single"
               >
                  Single Result
               </label>

               <input
                  onClick={(e) => handleResultType(e)}
                  type="radio"
                  id="group"
                  name="options"
               />
               <label className="common-blue" htmlFor="group">
                  Group Result
               </label>
            </form>

            {/* result form */}
            <form onSubmit={handleForm}>
               {isSingle ? (
                  <>
                     <label className="common-blue" htmlFor="roll">
                        Enter Your Roll*
                     </label>
                     <br />
                     <input
                        onChange={handleChange}
                        placeholder="Example: 101104 or 300125 and select 7th semester"
                        type="number"
                        name="roll"
                        className="roll"
                        required
                        autoFocus
                     />
                     {errors.rollErr && (
                        <p className="error-msg"> {errors.rollErr} </p>
                     )}
                  </>
               ) : (
                  <>
                     <label className="common-blue" htmlFor="fromRoll">
                        Start Roll*
                     </label>
                     <br />
                     <input
                        onChange={handleChange}
                        placeholder="Example: 101104"
                        type="number"
                        name="fromRoll"
                        className="roll"
                        id="fromRoll"
                        autoFocus
                        required
                     />
                     {(errors.fromRollErr || rangeError.startRollRange) && (
                        <p className="error-msg">
                           {errors.fromRollErr}
                           {errors.fromRollErr &&
                              rangeError.startRollRange &&
                              ' and '}
                           {rangeError.startRollRange}
                           {(errors.fromRollErr || rangeError.startRollRange) &&
                              '!'}
                        </p>
                     )}

                     <label className="common-blue" htmlFor="fromRoll">
                        End Roll*
                     </label>
                     <br />
                     <input
                        onChange={handleChange}
                        placeholder="Example: 101309"
                        type="number"
                        name="toRoll"
                        className="roll"
                        id="toRoll"
                        required
                     />
                     {(errors.toRollErr || rangeError.endRollRange) && (
                        <p className="error-msg">
                           {errors.toRollErr}
                           {errors.toRollErr &&
                              rangeError.endRollRange &&
                              ' and '}
                           {rangeError.endRollRange}
                           {(errors.toRollErr || rangeError.endRollRange) &&
                              '!'}
                        </p>
                     )}
                  </>
               )}

               <label className="common-blue" htmlFor="semester">
                  Select Your Semester*
               </label>
               <br />

               {isSingle ? (
                  <select
                     onChange={handleChange}
                     name="semester"
                     id="semester"
                     required
                  >
                     <option value="">Select Semester</option>
                     {/* <option value="4th"> 4th semester </option> */}
                     <option value="5th"> 5th Semester </option>
                     {/* <option value="6th"> 6th semester </option> */}
                     <option value="7th"> 7th Semester </option>
                     {/* <option value="8th"> 8th semester </option> */}
                     {/* <hr /> */}
                     {/* <option value="4thref"> 4th (B. challenge) </option> */}
                     {/* <option value="5thref"> 5th (referred) </option> */}
                     {/* <option value="6thref"> 6th (B. challenge) </option> */}
                     {/* <option value="7thref"> 7th (referred) </option> */}
                     {/* <option value="8thref"> 8th (B. challenge) </option> */}
                  </select>
               ) : (
                  <select
                     onChange={handleChange}
                     name="semesterg"
                     id="semester"
                     required
                  >
                     <option value="">Select Semester</option>
                     {/* <option value="4thtable"> 4th semester </option> */}
                     <option value="5thtable"> 5th semester </option>
                     {/* <option value="6thtable"> 6th semester </option> */}
                     <option value="7thtable"> 7th semester </option>
                     {/* <option value="8thtable"> 8th semester </option> */}
                     {/* <hr /> */}
                     {/* <option value="4threftable"> 4th (B. challenge) </option> */}
                     {/* <option value="5threftable"> 5th (referred) </option> */}
                     {/* <option value="6threftable"> 6th (B. challenge) </option> */}
                     {/* <option value="7threftable"> 7th (referred) </option> */}
                     {/* <option value="8threftable"> 8th (B. challenge) </option> */}
                  </select>
               )}

               <span>
                  <Link to="/terms"> Terms of service </Link>
               </span>

               <div className="form-btn text-center">
                  <button className="btn-form" type="submit">
                     Search
                  </button>
               </div>
            </form>
         </div>
      </div>
   );
};

export default Home;
